(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diagnostic-typeform"] && !window.DesignMode) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function() {
    var form = document.getElementById("product-form");
  
    form.addEventListener("submit", function(event) {
      event.preventDefault();
      
      var formData = new FormData(form);
  
      fetch("/cart/add.js", {
        method: "POST",
        body: formData
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        console.log(data);
      })
      .catch(function(error) {
        console.error("Une erreur s'est produite : " + error);
      });
    });
  });


  
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var laver = urlParams.get('laver');
  var hydrater = urlParams.get('hydrater');
  var coiffer = urlParams.get('coiffer');
  var tous_les_jours = urlParams.get('tous_les_jours');
  var une_fois_par_semaine = urlParams.get('une_fois_par_semaine');
  var tous_les_15_jours = urlParams.get('tous_les_15_jours');
  var en_cas_de_besoin = urlParams.get('en_cas_de_besoin');
  var en_bonus = urlParams.get('en_bonus');

  document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic').forEach(function(product) {
    var productID = product.getAttribute("id-product");
    if ( product.parentElement.classList.contains("laver") === true ){
      if ( laver && laver.includes(productID) ) {
        if (laver.includes("-") ) {
          var ids = laver.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active"); 
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }else if ( product.parentElement.classList.contains("hydrater") === true ){
      if ( hydrater && hydrater.includes(productID) ) {
        if (hydrater.includes("-") ) {
          var ids = hydrater.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active");
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }else if ( product.parentElement.classList.contains("coiffer") === true ){
      if ( coiffer && coiffer.includes(productID) ) {
        if (coiffer.includes("-") ) {
          var ids = coiffer.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active");
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }else if ( product.parentElement.classList.contains("tous_les_jours") === true ){
      if ( tous_les_jours && tous_les_jours.includes(productID) ) {
        if (tous_les_jours.includes("-") ) {
          var ids = tous_les_jours.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active");
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }else if ( product.parentElement.classList.contains("une_fois_par_semaine") === true ){
      if ( une_fois_par_semaine && une_fois_par_semaine.includes(productID) ) {
        if (une_fois_par_semaine.includes("-") ) {
          var ids = une_fois_par_semaine.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active");
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }else if ( product.parentElement.classList.contains("tous_les_15_jours") === true ){
      if ( tous_les_15_jours && tous_les_15_jours.includes(productID) ) {
        if (tous_les_15_jours.includes("-") ) {
          var ids = tous_les_15_jours.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active");
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }else if ( product.parentElement.classList.contains("en_cas_de_besoin") === true ){
      if ( en_cas_de_besoin && en_cas_de_besoin.includes(productID) ) {
        if (en_cas_de_besoin.includes("-") ) {
          var ids = en_cas_de_besoin.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active");
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }else if ( product.parentElement.classList.contains("en_bonus") === true ){
      if ( en_bonus && en_bonus.includes(productID) ) {
        if (en_bonus.includes("-") ) {
          var ids = en_bonus.split('-');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] == productID) {
              product.classList.add("active");
            }
          }
        }else{
          product.classList.add("active");
        }
      }else{
        product.remove();
      }
    }
  });

  document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products.desactive .product-diagnostic').forEach(function(product) {
    product.classList.remove("active");
  });

  
  function calculPrixPanier() {
    const productElements = document.querySelectorAll(".diag_typeform .block-products-diagnostic .liste-products .product-diagnostic.active .product-price");
    let totalPrice = 0;
    productElements.forEach((productElement) => {
      const priceText = parseFloat(productElement.innerHTML.trim().replace("$", "").replace("€", "").replace(",", "."));
      const price = parseFloat(priceText);
      if (!isNaN(price)) {
        totalPrice += price;
      }
    });
    document.querySelector(".diag_typeform form .button .price-diagnostic").innerHTML = totalPrice.toFixed(2) + " €";
    document.querySelector(".diag_typeform .titre-section .price-diagnostic").innerHTML = totalPrice.toFixed(2) + " €";
  }
  calculPrixPanier();

  var product_diagnostic = document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic');
  for (var i = 0; i < product_diagnostic.length; i++) {
  	product_diagnostic[i].addEventListener('click', function() {
      var div = this;
      if ( div.classList.contains("active") === true ){
        div.classList.remove("active");
      }else{
        div.classList.add("active");
      }
      calculPrixPanier();
  	});

    var idDoublon = product_diagnostic[i].getAttribute("id-product");
    if ( document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic.active[id-product="'+ idDoublon +'"]').length == 2 ){
      document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic.active[id-product="'+ idDoublon +'"]')[1].remove();
    }else if ( document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic.active[id-product="'+ idDoublon +'"]').length == 3 ){
      document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic.active[id-product="'+ idDoublon +'"]')[1].remove();
      document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic.active[id-product="'+ idDoublon +'"]')[2].remove();
    }
  }

  var listeProductsElements = document.querySelectorAll(".liste-products");
  for (var i = 0; i < listeProductsElements.length; i++) {
    var element = listeProductsElements[i];
    if (!element.querySelector(".product-diagnostic")) {
      element.parentNode.removeChild(element);
    }
  } 

  if (!!document.querySelector('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic[id-product="8151089381661"]') === true){
    document.querySelector('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic[id-product="8151089381661"] .product-desc').insertAdjacentHTML("beforeend", '<br><strong>Ne convient pas aux femmes enceintes ou allaitantes.</strong>');
  }

  document.querySelector(".diag_typeform .shopify-product-form .button").onclick = function() {
    
    var nbProductToAdd = document.querySelectorAll('.diag_typeform .block-products-diagnostic .liste-products .product-diagnostic.active');     
    if ( nbProductToAdd.length == 1 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
      
    }else if ( nbProductToAdd.length == 2 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
      }, 1500);
    }
      
    else if ( nbProductToAdd.length == 3 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
        }, 1500);
      }, 1500);
    }

    else if ( nbProductToAdd.length == 4 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {
            var variantID = nbProductToAdd[3].getAttribute("id-variant");
            document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
            document.querySelector('.diag_typeform form button').click();
            console.log(nbProductToAdd[3]);
            setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
          }, 1500);
        }, 1500);
      }, 1500);
    }

    else if ( nbProductToAdd.length == 5 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {
            var variantID = nbProductToAdd[3].getAttribute("id-variant");
            document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
            document.querySelector('.diag_typeform form button').click();
            console.log(nbProductToAdd[3]);
            setTimeout(function () {
              var variantID = nbProductToAdd[4].getAttribute("id-variant");
              document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
              document.querySelector('.diag_typeform form button').click();
              console.log(nbProductToAdd[4]);
              setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
            }, 1500);
          }, 1500);
        }, 1500);
      }, 1500);
    }

    else if ( nbProductToAdd.length == 6 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {
            var variantID = nbProductToAdd[3].getAttribute("id-variant");
            document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
            document.querySelector('.diag_typeform form button').click();
            console.log(nbProductToAdd[3]);
            setTimeout(function () {
              var variantID = nbProductToAdd[4].getAttribute("id-variant");
              document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
              document.querySelector('.diag_typeform form button').click();
              console.log(nbProductToAdd[4]);
              setTimeout(function () {
                var variantID = nbProductToAdd[5].getAttribute("id-variant");
                document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                document.querySelector('.diag_typeform form button').click();
                console.log(nbProductToAdd[5]);
                setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
              }, 1500);
            }, 1500);
          }, 1500);
        }, 1500);
      }, 1500);
    }
 
    else if ( nbProductToAdd.length == 7 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {
            var variantID = nbProductToAdd[3].getAttribute("id-variant");
            document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
            document.querySelector('.diag_typeform form button').click();
            console.log(nbProductToAdd[3]);
            setTimeout(function () {
              var variantID = nbProductToAdd[4].getAttribute("id-variant");
              document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
              document.querySelector('.diag_typeform form button').click();
              console.log(nbProductToAdd[4]);
              setTimeout(function () {
                var variantID = nbProductToAdd[5].getAttribute("id-variant");
                document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                document.querySelector('.diag_typeform form button').click();
                console.log(nbProductToAdd[5]);
                setTimeout(function () {
                  var variantID = nbProductToAdd[6].getAttribute("id-variant");
                  document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                  document.querySelector('.diag_typeform form button').click();
                  console.log(nbProductToAdd[6]);
                  setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
                }, 1500);
              }, 1500);
            }, 1500);
          }, 1500);
        }, 1500);
      }, 1500);
    }

    else if ( nbProductToAdd.length == 8 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {
            var variantID = nbProductToAdd[3].getAttribute("id-variant");
            document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
            document.querySelector('.diag_typeform form button').click();
            console.log(nbProductToAdd[3]);
            setTimeout(function () {
              var variantID = nbProductToAdd[4].getAttribute("id-variant");
              document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
              document.querySelector('.diag_typeform form button').click();
              console.log(nbProductToAdd[4]);
              setTimeout(function () {
                var variantID = nbProductToAdd[5].getAttribute("id-variant");
                document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                document.querySelector('.diag_typeform form button').click();
                console.log(nbProductToAdd[5]);
                setTimeout(function () {
                  var variantID = nbProductToAdd[6].getAttribute("id-variant");
                  document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                  document.querySelector('.diag_typeform form button').click();
                  console.log(nbProductToAdd[6]);
                  setTimeout(function () {
                    var variantID = nbProductToAdd[7].getAttribute("id-variant");
                    document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                    document.querySelector('.diag_typeform form button').click();
                    console.log(nbProductToAdd[7]);
                    setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
                  }, 1500);
                }, 1500);
              }, 1500);
            }, 1500);
          }, 1500);
        }, 1500);
      }, 1500);
    }

    else if ( nbProductToAdd.length == 9 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {
            var variantID = nbProductToAdd[3].getAttribute("id-variant");
            document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
            document.querySelector('.diag_typeform form button').click();
            console.log(nbProductToAdd[3]);
            setTimeout(function () {
              var variantID = nbProductToAdd[4].getAttribute("id-variant");
              document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
              document.querySelector('.diag_typeform form button').click();
              console.log(nbProductToAdd[4]);
              setTimeout(function () {
                var variantID = nbProductToAdd[5].getAttribute("id-variant");
                document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                document.querySelector('.diag_typeform form button').click();
                console.log(nbProductToAdd[5]);
                setTimeout(function () {
                  var variantID = nbProductToAdd[6].getAttribute("id-variant");
                  document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                  document.querySelector('.diag_typeform form button').click();
                  console.log(nbProductToAdd[6]);
                  setTimeout(function () {
                    var variantID = nbProductToAdd[7].getAttribute("id-variant");
                    document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                    document.querySelector('.diag_typeform form button').click();
                    console.log(nbProductToAdd[7]);
                    setTimeout(function () {
                      var variantID = nbProductToAdd[8].getAttribute("id-variant");
                      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                      document.querySelector('.diag_typeform form button').click();
                      console.log(nbProductToAdd[8]);
                      setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
                    }, 1500);
                  }, 1500);
                }, 1500);
              }, 1500);
            }, 1500);
          }, 1500);
        }, 1500);
      }, 1500);
    }

    else if ( nbProductToAdd.length == 10 ){
      document.head.insertAdjacentHTML('beforeend', '<style>html{pointer-events: none !important;}*,html,body,p,a,div{cursor: wait !important;}</style>');
      var variantID = nbProductToAdd[0].getAttribute("id-variant");
      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
      document.querySelector('.diag_typeform form button').click();
      console.log(nbProductToAdd[0]);
      setTimeout(function () {
        var variantID = nbProductToAdd[1].getAttribute("id-variant");
        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
        document.querySelector('.diag_typeform form button').click();
        console.log(nbProductToAdd[1]);
        setTimeout(function () {
          var variantID = nbProductToAdd[2].getAttribute("id-variant");
          document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
          document.querySelector('.diag_typeform form button').click();
          console.log(nbProductToAdd[2]);
          setTimeout(function () {
            var variantID = nbProductToAdd[3].getAttribute("id-variant");
            document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
            document.querySelector('.diag_typeform form button').click();
            console.log(nbProductToAdd[3]);
            setTimeout(function () {
              var variantID = nbProductToAdd[4].getAttribute("id-variant");
              document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
              document.querySelector('.diag_typeform form button').click();
              console.log(nbProductToAdd[4]);
              setTimeout(function () {
                var variantID = nbProductToAdd[5].getAttribute("id-variant");
                document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                document.querySelector('.diag_typeform form button').click();
                console.log(nbProductToAdd[5]);
                setTimeout(function () {
                  var variantID = nbProductToAdd[6].getAttribute("id-variant");
                  document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                  document.querySelector('.diag_typeform form button').click();
                  console.log(nbProductToAdd[6]);
                  setTimeout(function () {
                    var variantID = nbProductToAdd[7].getAttribute("id-variant");
                    document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                    document.querySelector('.diag_typeform form button').click();
                    console.log(nbProductToAdd[7]);
                    setTimeout(function () {
                      var variantID = nbProductToAdd[8].getAttribute("id-variant");
                      document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                      document.querySelector('.diag_typeform form button').click();
                      console.log(nbProductToAdd[8]);
                      setTimeout(function () {
                        var variantID = nbProductToAdd[9].getAttribute("id-variant");
                        document.querySelector('.diag_typeform form input[name="id"]').setAttribute("value", variantID);
                        document.querySelector('.diag_typeform form button').click();
                        console.log(nbProductToAdd[9]);
                        setTimeout(function () {window.location.replace("https://thomastuccinardi.com/cart");}, 1000);
                      }, 1500);
                    }, 1500);
                  }, 1500);
                }, 1500);
              }, 1500);
            }, 1500);
          }, 1500);
        }, 1500);
      }, 1500);
    }  
  };

  var widthBtn = document.querySelector(".diag_typeform .shopify-product-form .button").offsetWidth;
  document.querySelector("#product-form .code-promo").style.cssText = "width: "+ widthBtn +"px;";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden_none', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden_none');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden_none', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden_none');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!!document.querySelector(".upsell-typeform") === true){

    var idProduct = document.querySelector('.product-form .shopify-product-form input[name="id"]').getAttribute("value");
    var typeformSpan = document.querySelectorAll('.upsell-typeform .choix-typeform');
    for (var i = 0; i < typeformSpan.length; i++) {
      typeformSpan[i].addEventListener('click', function() {
        if ( this.classList[1] === "active" ){
          this.classList.remove("active");
          var priceATC = parseFloat(document.querySelector(".product-form__buttons .product-form__submit .button_price .button_price_regular").textContent.replace(',', '.').replace('€',''));
          var priceUpsell = parseFloat(this.querySelector(".prix-produit").textContent.replace(',', '.').replace('€',''));
          document.querySelector(".product-form__buttons .product-form__submit .button_price .button_price_regular").textContent = parseFloat(priceATC - priceUpsell).toFixed(2) + "€";
        }else{
          this.classList.add("active");
          var priceATC = parseFloat(document.querySelector(".product-form__buttons .product-form__submit .button_price .button_price_regular").textContent.replace(',', '.').replace('€',''));
          var priceUpsell = parseFloat(this.querySelector(".prix-produit").textContent.replace(',', '.').replace('€',''));
          console.log(priceATC);console.log(priceUpsell);  
          document.querySelector(".product-form__buttons .product-form__submit .button_price .button_price_regular").textContent = parseFloat(priceATC + priceUpsell).toFixed(2) + "€";
        }
      });
    }

    var lastExecutionTime = 0;
    document.querySelector('.product-form .product-form__submit').onclick = function() {
      var currentTime = Date.now();
      if (currentTime - lastExecutionTime >= 10000) {
        lastExecutionTime = currentTime;
    
        if (!!document.querySelector(".upsell-typeform-1") === true && document.querySelector(".upsell-typeform-1 .choix-typeform").classList.contains("active") === true){
          document.querySelector("header.header cart-drawer").classList.add("hidden");
          setTimeout(function () {
            console.log("Upsell 1");
            var idTypeform1 = document.querySelector(".upsell-typeform-1 .choix-typeform>span").getAttribute("id-product");
            document.querySelector('.product-form .shopify-product-form input[name="id"]').setAttribute("value", idTypeform1);
            document.querySelector('.product-form .product-form__submit').click();
          }, (1000));
        }

        if (!!document.querySelector(".upsell-typeform-2") === true && document.querySelector(".upsell-typeform-2 .choix-typeform").classList.contains("active") === true){
          document.querySelector("header.header cart-drawer").classList.add("hidden");
          setTimeout(function () {
            console.log("Upsell 2");
            var idTypeform1 = document.querySelector(".upsell-typeform-2 .choix-typeform>span").getAttribute("id-product");
            document.querySelector('.product-form .shopify-product-form input[name="id"]').setAttribute("value", idTypeform1);
            document.querySelector('.product-form .product-form__submit').click();
            document.querySelector('.product-form .shopify-product-form input[name="id"]').setAttribute("value", idProduct);
          }, (2000));
        }
        setTimeout(function () {
          document.querySelector("header.header cart-drawer").classList.remove("hidden");
        }, (2000));
      }
    };

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !window.DesignMode) return;
  try {
    
  var lirePlus = document.querySelectorAll('.rich-text__blocks .lire-plus');
  for (var i = 0; i < lirePlus.length; i++) {
  	lirePlus[i].addEventListener('click', function(event) {
      console.log("KLICK");
      var lirePlusClick = event.target;
      if ( lirePlusClick.parentElement.querySelector(".rich-text__text.collection_width").classList.contains("open") === true ){
        lirePlusClick.parentElement.querySelector(".rich-text__text.collection_width").classList.remove("open");
        event.target.textContent = "Lire plus"; 
      }else{
        lirePlusClick.parentElement.querySelector(".rich-text__text.collection_width").classList.add("open");
        event.target.textContent = "Lire moins";
      }
  	});
  }

  } catch(e) { console.error(e); }
})();
})();
